/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  DASHBOARD_END_POINT: "https://sr-backend-api.takeleap.in",
  API_END_POINT: 'https://sr-audit.takeleap.in/',/* new base path for backend of audit,because .96 QA server is crashing a lot, changes made as per Ravi Shankar suggestion */
  // DASHBOARD_END_POINT: "http://localhost:3011",
  //API_END_POINT: "http://3.108.55.96:8081/",
  // API_END_POINT: "http://localhost:8081/",
  origin: "AUDITOR_REMOTE",
  IMAGES_AWS_PREFIX: "https://auditor-master-images.seekright.com/SeekRight/",
  // IMAGES_AWS_PREFIX: "https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/",
  RECTIFICATION_IMAGES_AWS_PREFIX: "https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/",
  IMAGES_TEST_AUDIT_PREFIX: "https://dashboard-images.seekright.com/SeekRight/"

};
